export default __webpack_public_path__ + "static/media/retailer_astra_btn.73cbf367.png";